var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { env } from "../../constants/global.constants";
import { api } from "../../services/http.service";
import "./products.css";
import { modalServiceSubject } from "../../services/modal.service";
import { useNavigate, useParams, useLocation } from "react-router";
import { ProductDetail } from "./detail";
import Modal from "react-modal";
import { CurrencyFormat, dateTimeFormat, gtmSelectItem, gtmViewItem, gtmViewItemList } from "../../services/misc.functions";
import { isMobile } from "../../App";
import { auth } from "../../store/auth.store";
import paths from "../../paths";
var requestStatusMap = {
    0: {
        class: "warning",
        label: "Beklemede",
    },
    1: {
        class: "success",
        label: "Onaylandı",
    },
    2: {
        class: "danger",
        label: "Stokta Yok",
    },
    3: {
        class: "info",
        label: "Gönderildi",
    },
};
export function Products() {
    var _a = useState([]), dataList = _a[0], setDataList = _a[1];
    var _b = useState([]), requestList = _b[0], setRequestList = _b[1];
    var _c = useState(0), selectedTab = _c[0], setSelectedTab = _c[1];
    var params = useParams();
    var navigate = useNavigate();
    var location = useLocation();
    useEffect(function () {
        getRequests();
        setSelectedTab(0); // Reset tab when page loads
        api
            .start("get", env.accounting_api + "/product/api/get-products/", null, false)
            .then(function (res) {
            // console.log(res)
            setDataList(res.data);
            gtmViewItemList(res.data, 'Ödüller');
        });
    }, [location.pathname]);
    var getRequests = function () {
        api
            .start("get", env.accounting_api + "/product/api/list-prize-request/", null, true)
            .then(function (res) {
            // console.log(res)
            if (res && res.status) {
                setRequestList(res.data);
            }
        });
    };
    if ((params === null || params === void 0 ? void 0 : params.id) && dataList && dataList.length > 0) {
        var product = dataList.find(function (el) { return el.id === Number(params.id); });
        return _jsx(ProductDetail, { product: product });
    }
    var productTabs = [
        {
            key: "rewards",
            label: "Ödüller",
            isActive: selectedTab === 0,
            visible: true,
            onSelect: function () { return setSelectedTab(0); },
        },
        {
            key: "requests",
            label: "Taleplerim",
            isActive: selectedTab === 1,
            visible: auth.member,
            onSelect: function () { return setSelectedTab(1); },
        },
    ].filter(function (tab) { return tab.visible; });
    return (_jsxs(_Fragment, { children: [isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row mt-3 raffle-page-title-bar" }, { children: _jsx("h1", __assign({ className: "fs-5 fw-bold mx-2 text-uppercase" }, { children: "\u00D6d\u00FCller" })) })), _jsx("div", __assign({ className: "row inner-page-top-tabs" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("div", __assign({ className: "custom-tabs custom-tabs-mobile" }, { children: productTabs.map(function (tab) { return (_jsx("div", __assign({ className: "custom-tab-item ".concat(tab.isActive ? "active" : ""), role: "button", tabIndex: 0, onClick: tab.onSelect, onKeyDown: function (event) {
                                        if (event.key === "Enter" || event.key === " ") {
                                            event.preventDefault();
                                            tab.onSelect();
                                        }
                                    } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: tab.label })) }), tab.key)); }) })) })) }))] })), !isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row mt-3 raffle-page-title-bar" }, { children: _jsx("h1", __assign({ className: "fs-5 fw-bold mx-2 text-uppercase" }, { children: "\u00D6d\u00FCller" })) })), _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "mb-0 mt-1" }, { children: _jsxs("div", __assign({ className: "custom-tabs" }, { children: [_jsx("div", __assign({ className: "custom-tab-item ".concat(selectedTab === 0 ? 'active' : ''), onClick: function () { return setSelectedTab(0); } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: "\u00D6d\u00FCller" })) })), auth.member && (_jsx("div", __assign({ className: "custom-tab-item ".concat(selectedTab === 1 ? 'active' : ''), onClick: function () { return setSelectedTab(1); } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: "Taleplerim" })) })))] })) })) }))] })), _jsxs("div", __assign({ className: "row products-list-row" }, { children: [selectedTab == 0 && (_jsx(_Fragment, { children: dataList &&
                            dataList.map(function (el, key) {
                                return (_jsx("div", __assign({ className: "col-6 col-md-3 col-lg-2 my-2" }, { children: _jsx(Product, { product: el }) }), "".concat(key)));
                            }) })), selectedTab == 1 && (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "prize-request-container" }, { children: [requestList.length == 0 && _jsx(_Fragment, { children: _jsxs("div", __assign({ className: "empty-state" }, { children: [_jsx("p", __assign({ className: "text-center" }, { children: "Hen\u00FCz bir talebiniz bulunmamaktad\u0131r." })), _jsx("div", __assign({ className: "d-flex justify-content-center" }, { children: _jsx("button", __assign({ className: "mx-auto btn btn-primary mt-3", onClick: function () {
                                                        setSelectedTab(0);
                                                    } }, { children: "\u00D6d\u00FClleri \u0130ncele" })) }))] })) }), requestList.map(function (el) {
                                    return (_jsxs("div", __assign({ className: "prize-request-item" }, { children: [_jsx("div", __assign({ className: "prize-request-image" }, { children: _jsx("img", { src: "".concat(env.cdn_host, "/media/").concat(el.product__ProductPicture), alt: el.name }) })), _jsxs("div", __assign({ className: "prize-request-content" }, { children: [_jsx("div", __assign({ className: "prize-request-header" }, { children: _jsx("h3", { children: el.name }) })), _jsxs("div", __assign({ className: "prize-request-details" }, { children: [_jsxs("span", __assign({ className: "detail-item" }, { children: [_jsx("strong", { children: "Talep Tarihi:" }), " ", dateTimeFormat(el.create_date)] })), _jsxs("span", __assign({ className: "detail-item" }, { children: [_jsx("strong", { children: "Talep Adedi:" }), " ", Number(el.amount).toFixed(0), " adet"] }))] }))] })), _jsx("div", __assign({ className: "prize-request-status-wrapper" }, { children: _jsx("div", __assign({ className: "prize-request-status ".concat(requestStatusMap[el.status].class) }, { children: requestStatusMap[el.status].label })) }))] }), "request-item-" + el.id));
                                })] })) }))] }))] }));
}
var errorMessagesMap = {
    member_error: "Üye girişi yapmalısınız.",
    product_error: "Ürün bulunamadı.",
    balance_point_available_error: "Yetersiz Bakiye",
};
export function Product(props) {
    var _a = useState(false), added = _a[0], setAdded = _a[1];
    var product = props.product;
    var _b = useState(null), itemModal = _b[0], setItemModal = _b[1];
    var navigate = useNavigate();
    var createRequest = function (product) {
        if (auth.member) {
            if (added && added > 0) {
                api
                    .start("post", env.accounting_api + "/product/api/create-prize-request/", {
                    product_id: product.id,
                    amount: added,
                }, true)
                    .then(function (res) {
                    if (res && res.status) {
                        setAdded(false);
                        modalServiceSubject.next({
                            case: "success",
                            title: "Talep Aldık!",
                            content: "<p class=\"text-center\">Talebiniz olu\u015Fturuldu. Talep kontrol\u00FC sonras\u0131nda sizleri eposta ve sms yolu ile bilgilendirece\u011Fiz. \n               E\u011Fer eposta yada SMS alm\u0131yorsan\u0131z l\u00FCtfen ileti\u015Fim ayarlar\u0131n\u0131z\u0131 kontrol edin ve operat\u00F6re\u00FCn\u00FCzden gerekli izinleri talep edin.\n              </p>",
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-success w-100",
                                },
                            },
                        });
                    }
                    else {
                        modalServiceSubject.next({
                            case: "danger",
                            title: errorMessagesMap[res.error] || "Bakiyeniz Yetersiz 😞",
                            content: "<p class=\"text-center\">\n                ".concat(res.message, "\n                \n                <br />\u00D6d\u00FCl katalo\u011Fundan sadece oyunlarda kazand\u0131\u011F\u0131n\u0131z \u015EP puanlar\u0131n\u0131z ile \u00F6d\u00FCl talep edebilirsiniz.<br /><br />\n                \u015Eans oyunlar\u0131m\u0131zdan oynayarak \u015EP Puan kazanabilir ve \u00F6d\u00FCl\u00FCn\u00FCz\u00FC talep edebilirsiniz.  \n               \n              </p>"),
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-danger w-100",
                                },
                            },
                        });
                    }
                });
            }
        }
        else {
            if (isMobile) {
                navigate(paths.landing.url);
            }
            else {
                modalServiceSubject.next({
                    class: "success",
                    title: "Üye Girişi",
                    content: "<p>Sat\u0131nalma yapabilmeniz i\u00E7in \u00F6nce oturum a\u00E7man\u0131z gerekli. \u00DCye de\u011Filseniz hemen \u00FCye olabilir yada giri\u015F yaparak al\u0131\u015Fveri\u015Finizi tamamlaya bilirsiniz.</p>",
                    confirm: {
                        sure: {
                            label: "Giriş Yap",
                            class: "btn btn-success",
                            action: function () {
                                navigate(paths.login.url);
                            },
                        },
                        cancel: {
                            label: "Üye Ol",
                            class: "btn btn-info",
                            action: function () {
                                navigate(paths.register.url);
                            },
                        },
                    },
                });
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "product-widget" }, { children: [_jsxs("div", __assign({ className: "body pointer" }, { children: [_jsx("div", __assign({ className: "image-wrapper mb-1", style: { aspectRatio: "1 / 1", overflow: "hidden" }, onClick: function () {
                                    setItemModal(product);
                                    gtmSelectItem([product], 'Ödüller');
                                } }, { children: _jsx("img", { src: env.cdn_host + "/media/" + product.ProductPicture, alt: product.code, style: { width: "100%", height: "100%", objectFit: "cover" } }) })), _jsx("h2", __assign({ onClick: function () {
                                    setItemModal(product);
                                    gtmSelectItem([product], 'Ödüller');
                                } }, { children: product.name })), _jsxs("span", __assign({ className: "d-flex justify-content-between mt-2" }, { children: [added !== false && (_jsx("div", __assign({ className: "add" }, { children: _jsxs("div", __assign({ className: "input me-3", onClick: function (e) { e.stopPropagation(); } }, { children: [_jsx("i", __assign({ onClick: function (e) {
                                                        e.stopPropagation();
                                                        if (added > 1) {
                                                            setAdded(added - 1);
                                                        }
                                                        else {
                                                            setAdded(false);
                                                        }
                                                    } }, { children: "-" })), _jsx("input", { disabled: true, className: "no-arrows", type: "number", value: added || "", onClick: function (e) { e.stopPropagation(); }, onChange: function (e) {
                                                        setAdded(e.target.value);
                                                    }, onBlur: function (e) {
                                                        if (e.target.value === "") {
                                                            setAdded(false);
                                                        }
                                                    }, max: 100, step: 1, min: 1 }), _jsx("i", __assign({ onClick: function (e) {
                                                        e.stopPropagation();
                                                        setAdded(added + 1);
                                                    } }, { children: "+" }))] })) }))), _jsxs("h2", { children: [CurrencyFormat(product.price, 0), " \u015EP"] })] }))] })), _jsx("div", __assign({ className: "foot p-2" }, { children: _jsx("button", __assign({ className: added !== false ? "added" : "", onClick: function () {
                                if (added === false) {
                                    setAdded(1);
                                }
                                else {
                                    // Giriş yapmamış kullanıcı kontrolü
                                    if (!auth.member) {
                                        modalServiceSubject.next({
                                            case: "info",
                                            title: "Giriş Gerekli",
                                            content: "<p>\u00D6d\u00FCl talebinde bulunabilmek i\u00E7in giri\u015F yapman\u0131z gerekmektedir.</p>",
                                            confirm: {
                                                cancel: {
                                                    class: "btn btn-outline-danger",
                                                    label: "Vazgeç",
                                                },
                                                sure: {
                                                    class: "btn btn-success",
                                                    label: "Giriş Yap",
                                                    action: function () {
                                                        navigate(paths.login.url);
                                                    },
                                                },
                                            },
                                        });
                                    }
                                    else {
                                        modalServiceSubject.next({
                                            case: "info",
                                            title: "Talep Onayı",
                                            content: "<p><b>".concat(CurrencyFormat(product.price * added, 0), " \u015EP</b> kar\u015F\u0131l\u0131\u011F\u0131nda <b>").concat(added, " adet</b> ").concat(product.name, " talebini onayl\u0131yor musunuz?</p><p>Hediye \u00E7ek taleplerinizin taraf\u0131n\u0131za teslim s\u00FCresi 2 - 4 i\u015F g\u00FCn\u00FCd\u00FCr. </p>"),
                                            confirm: {
                                                cancel: {
                                                    class: "btn btn-outline-danger",
                                                    label: "Vazgeç",
                                                },
                                                sure: {
                                                    class: "btn btn-success",
                                                    label: "Onayla",
                                                    action: function () {
                                                        createRequest(product);
                                                    },
                                                },
                                            },
                                        });
                                    }
                                }
                            } }, { children: added !== false ? "TALEP ET" : "Talep Oluştur" })) }))] })), _jsx(Modal, __assign({ isOpen: itemModal !== null, className: "default product-detail-modal", onRequestClose: function () {
                    setItemModal(null);
                }, onAfterOpen: function () {
                    gtmViewItem([itemModal], 'Ödüller');
                }, contentLabel: "" }, { children: itemModal && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "head" }, { children: _jsx("h2", { children: itemModal.name }) })), _jsxs("div", __assign({ className: "modal-body" }, { children: [_jsx("img", { className: "picture", src: env.cdn_host + "/media/" + itemModal.ProductPicture, alt: product.code }), _jsx("div", { className: "info", dangerouslySetInnerHTML: { __html: itemModal.description.replaceAll('\n', '<br/>') } })] })), _jsx("div", __assign({ className: "modal-ticket-footer text-end" }, { children: _jsx("div", __assign({ className: "body-row row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("button", __assign({ type: "button", onClick: function () {
                                            setItemModal(null);
                                        }, className: "btn w-100 custom-btn-danger me-2" }, { children: "Kapat" })) })) })) }))] })) }))] }));
}
